import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const VulnerabilityScanning: React.FC = () => {
  const sections = [
    {
      title: 'Comprehensive Vulnerability Scanning',
      content: 'Our vulnerability scanning services provide continuous monitoring and assessment of your IT infrastructure to identify security weaknesses before they can be exploited by attackers. We use industry-leading tools and expert analysis to deliver actionable insights for improving your security posture.',
      benefits: [
        'Network and infrastructure vulnerability scanning',
        'Web application security assessment',
        'Database and server vulnerability analysis',
        'Compliance-focused scanning (PCI DSS, HIPAA)',
        'Continuous monitoring and alerting'
      ]
    },
    {
      title: 'Advanced Scanning Capabilities',
      content: 'Our scanning services cover all aspects of your IT environment with both authenticated and unauthenticated scans to provide comprehensive coverage.',
      benefits: [
        'Internal and external network scanning',
        'Authenticated credential-based assessments',
        'Cloud infrastructure vulnerability assessment',
        'IoT and mobile device security scanning',
        'Custom application and API testing'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Vulnerability Scanning"
      subtitle="Comprehensive vulnerability scanning services to identify and assess security weaknesses across your entire IT infrastructure."
      sections={sections}
    />
  );
};

export default VulnerabilityScanning;

